import { render, staticRenderFns } from "./PowerBiViewer.vue?vue&type=template&id=19835768&scoped=true"
import script from "./PowerBiViewer.vue?vue&type=script&lang=js"
export * from "./PowerBiViewer.vue?vue&type=script&lang=js"
import style1 from "./PowerBiViewer.vue?vue&type=style&index=1&id=19835768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19835768",
  null
  
)

export default component.exports